/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('FilesCtrl', function(
    $scope,
    $q,
    $routeParams,
    Activity,
    modules_url,
    ErrorThrower
) {
    const errorManager         = new ErrorThrower;
    $scope.fetching      = false;
    $scope.regular_files = [];
    $scope.stage_files   = [];
    $scope.modules_url   = modules_url;

	console.log("initialy, scope.stage = ", $scope.stage);
	
    $scope.buildTree = function(init) {
        if (init == null) { init = true; }
        $scope.tree = [];
        if (init) {
            $scope.route_path   = '';
            $scope.route_length = 0;
        }

        $scope.files.map(function(file) {
            const path        = file.filename.split('/');
            const regex       = '^' + $scope.route_path.replace(/\//, '\/') + '.*';
            let tree_offset = 0;

            // Verifie si le nom du dossier n'est pas existant
            $scope.tree.map(node => tree_offset += (node.name === path[$scope.route_length]) && ('dir' === node.type));

            // Verifie si le fichier appartient bien au dossier en utilisant les routes
            if ($scope.route_length) {
                tree_offset += (file.filename.match(regex) == null);
            }

            if (!tree_offset) {
                $scope.tree.push({
                    name: path[$scope.route_length],
                    type: path[$scope.route_length + 1] ? 'dir'
                    : path[0].endsWith('.zip') ? 'archive'
                    : 'file',
                    path: path[$scope.route_length + 1] ? '' : file.path
                });
            }
        });
    };

    $scope.routeChange = function(dir) {
        if (dir == null) { dir = ''; }
        if (dir) {
            $scope.route_path   = $scope.route_path.replace(new RegExp(dir + '/.*'), '') + dir + '/';
            $scope.route_length = $scope.route_path.split('/').length - 1;
        } else {
            $scope.route_path = $scope.route_path.replace(/[^\/].+\/$/, '');
            $scope.route_length--;
        }
        return $scope.buildTree(false);
    };

    $scope.$watch('stage', function() {
        let promise;
        if ($scope.fetching === true) { return; }
        const promises        = [];
        $scope.fetching = true;

        promise = Activity
            .files($scope.project)
            .$promise
            .then(files => $scope.regular_files = files.map(function(file) {
				file.path = encodeURI(file.path);
				return file;
			}))
			.catch(function(api_error) {
                if (403 !== api_error.status) {
                    errorManager.minor(api_error.statusText);
                }
			});
        promises.push(promise);

        if (($scope.stage !== null) && ('' !== $scope.stage.trim())) {
            promise = Activity
                .stageFile(angular.extend({ }, $scope.project, { stage: $scope.stage }))
                .$promise
                .then(files => $scope.stage_files = files.map(function(file) {
					file.path = encodeURI(file.path);
					return file;
				})).catch(function(api_error) {
                    if (403 !== api_error.status) {
                        errorManager.minor(api_error.statusText);
                    }
				});
            promises.push(promise);
        }

        $q.all(promises)
		//.then(() => $scope.files = $scope.regular_files.concat($scope.stage_files))
			.finally(function() {
				$scope.files = $scope.regular_files.concat($scope.stage_files);
				$scope.buildTree();
				$scope.stage_files = [];
				$scope.fetching = false;
			});
    });

    return $scope.sendFileToReader = function(file_url, file_name) {
        const file = {
            url:  file_url,
            name: file_name
        };

        return $scope.$emit('file_reader', file);
    };
});
